import { useTranslations } from "next-intl";
import { useParams } from "react-router-dom";
import { PageShell, Heading, Text, buttonClasses } from "@/components/ui";

/** OPS-8: catch-all route — an unknown URL gets a page, not a blank screen. */
export function NotFoundPage() {
  const t = useTranslations("errors");
  const { tenantSlug } = useParams<{ tenantSlug?: string }>();
  const home = tenantSlug ? `/t/${tenantSlug}` : "/";

  return (
    <PageShell data-testid="not-found-page">
      <Heading as="h1" level="page">
        {t("pageNotFoundTitle")}
      </Heading>
      <Text tone="muted" className="mt-3">
        {t("pageNotFoundBody")}
      </Text>
      <a href={home} className={buttonClasses({ variant: "primary" }) + " mt-6 inline-flex"}>
        {t("pageNotFoundHome")}
      </a>
    </PageShell>
  );
}
